import { render, staticRenderFns } from "./MateriInput.vue?vue&type=template&id=f7c0f9dc&"
import script from "./MateriInput.vue?vue&type=script&lang=js&"
export * from "./MateriInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MateriInput.vue"
export default component.exports